import React,{useState,useEffect,useRef} from 'react';
import { Typography, Input, Button, Cascader, Dropdown, Menu, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import styles from './SearchConponent.module.scss';
import {useAppDispatch,useAppSelector} from '@/store/hooks';
import { setSearchValue,setClassificationText} from '@/store/slices/searchBarSlice';
import { getProductCategoryAllList } from '@/api/products';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
interface HomeChildProps {
  // children: React.ReactNode;
  getMessage?: (str: string, activeTabIndex?: number) => void; // 可选的回调函数
  keyword?: string;
  currentTabIndex?: number; // 当前页面的tab索引
}


const SearchConponent: React.FC<HomeChildProps> = ({getMessage,keyword,currentTabIndex}) => {
  //搜索关键字
  const [inputValue, setInputValue] = useState<string>('');
  const inputRef = useRef<any>(null);
  
  //console.log('SearchConponent render - keyword:', keyword, 'inputValue:', inputValue);
  const location = useLocation();
  const navigate = useNavigate();
  const isEmergencyServiceRoute = location.pathname.toLowerCase().includes('/emergencyservice');
  const isHomePage = location.pathname === '/' || location.pathname === '/home';
  const { t, i18n } = useTranslation();
  // 下拉筛选状态
  const [selectedFilter, setSelectedFilter] = useState<string>('Product');
  
  // 下拉菜单选项
  // const filterOptions = ;
  const [filterOptions, setFilterOptions] = useState([
    { key: 'Product', label: t('common.Product') },
    { key: 'Service', label: t('common.Service') },
    { key: 'Store', label: t('common.Store') }
  ]);
  // tab索引映射
  const tabIndexMap: { [key: string]: number } = {
    'Product': 0,
    'Service': 1,
    'Store': 2
  };

  useEffect(() => {
    setFilterOptions([
    { key: 'Product', label: t('common.Product') },
    { key: 'Service', label: t('common.Service') },
    { key: 'Store', label: t('common.Store') }
  ])
  }, [i18n.language]); // 将语言作为依赖项
  //搜索
  const searchAction = (): void => {
    // 如果在首页，使用下拉选择的tab索引
    // 如果在其他页面，使用当前页面的tab索引
    const tabIndex = isHomePage ? (tabIndexMap[selectedFilter] ?? 0) : (currentTabIndex ?? 0);
    
    // 如果在首页，跳转到搜索页面并传递参数
    if (isHomePage) {
      navigate(`/searchList?keyword=${encodeURIComponent(inputValue)}&activeTabIndex=${tabIndex}`);
    } else {
      // 如果在其他页面，调用回调函数
      getMessage && getMessage(inputValue, tabIndex);
    }
  }

  // 处理键盘回车事件
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (e.key === 'Enter') {
      searchAction();
    }
  }

  // 处理移动端搜索事件
  const handleSearch = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    searchAction();
  }

  // 处理下拉筛选选择
  const handleFilterChange = ({ key }: { key: string }): void => {
    setSelectedFilter(key);
  }

  useEffect(()=>{
    //console.log('SearchConponent useEffect triggered with keyword:', keyword);
    const newValue = keyword || '';
    //console.log('Setting inputValue to:', newValue);
    setInputValue(newValue);
  },[keyword])



  return (
    <div className={`${styles['search-bar']} ${isEmergencyServiceRoute ? styles['is-emergency'] : ''} ${isHomePage ? styles['is-home'] : ''}`}>
      <form className={styles['search-box']} onSubmit={handleSearch}>
        {isHomePage ? (
          <Dropdown
            menu={{
              items: filterOptions,
              onClick: handleFilterChange,
              selectedKeys: [selectedFilter]
            }}
            trigger={['click']}
            placement="bottomLeft"
          >
            <div className={styles['filter-dropdown']}>
              <span className={styles['filter-text']}>{filterOptions.find(item=>item.key === selectedFilter)?.label ?? '' }</span>
              <DownOutlined className={styles['filter-arrow']} />
            </div>
          </Dropdown>
        ) : (
          <div className={styles['search-icon']}></div>
        )}
        <div className={styles['divider']}></div>
        <Input  
          ref={inputRef}
          className={styles['search-input']}
          value={inputValue}
          onChange={(e)=>setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={isHomePage ? t("common.MobilePhones") : t("common.Searchmore")}
        />
        <Button className={styles['search-btn']} onClick={searchAction}>{t('common.Search')}</Button>
      </form>
    
    </div>
  );
};

export default SearchConponent; 